module.exports = __webpack_public_path__ + "static/media/memory-dclick.b9403cee.png";